<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager']"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        <a> Massenerfassung </a>
      </li>
    </ul>
  </div>
</div>

<div class="page-content px-4 pb-2 overflow-auto">
  <div class="max-w-7xl mx-auto flex flex-col gap-3">
    <div class="flex flex-col md:flex-row flex-wrap bg-base-100 border border-base-300 shadow-sm rounded-md w-full">
      <div class="bm-card flex-1 max-w-1/3">
        <div class="bm-card-body">
          <div class="bm-card-title">Artikel Metadaten</div>
          <form [formGroup]="metaForm">
            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">Typ</label>
              <ng-select
                class="w-full"
                [items]="templates"
                bindLabel="combined"
                autofocus
                #metaType
                (close)="metaType.blur()"
                placeholder="Artikeltyp auswählen"
                formControlName="metaType"
              />

              <label for="kundeBentomax" class="bm-fieldset-label">Eigentümer</label>
              <label class="bm-fieldset-label">
                <input
                  class="bm-radio mr-2"
                  type="radio"
                  name="ownerSelect"
                  id="kundeBentomax"
                  formControlName="ownerSelect"
                  value="bentomax"
                  [checked]="true"
                />
                Bentomax
              </label>
              <label class="bm-fieldset-label">
                <input
                  class="bm-radio mr-2"
                  type="radio"
                  name="ownerSelect"
                  id="kundeOther"
                  formControlName="ownerSelect"
                  value="other"
                />
                Kunde
              </label>

              @if (showCustomer()) {
                <ng-select
                  class="w-full"
                  [items]="owner"
                  bindLabel="name"
                  autofocus
                  bindValue="id"
                  placeholder="Eigentümer auswählen"
                  formControlName="metaOwner"
                  #metaOwner
                  (close)="metaOwner.blur()"
                />
              }

              <label for="inputCount" class="bm-fieldset-label">Anzahl</label>
              <input
                type="number"
                class="bm-input w-full"
                id="inputCount"
                formControlName="metaAmount"
                placeholder="Anzahl Teile"
              />
              <label>
                Hat der Artikel die erfassung der Seriennummer aktiviert:<br />
                Die Anzahl wird nur zum Abgleich mit der Anzahl der gescannten Seriennummern benötigt. Das Feld ist
                deshalb optional.<br />
                Ansonsten ist es ein Pflichtfeld.
              </label>
            </fieldset>

            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label" for="inputDeliveryNoteNumber">externer Lieferschein</label>
              <input
                type="text"
                class="bm-input w-full"
                id="inputDeliveryNoteNumber"
                formControlName="deliveryNoteNumber"
                placeholder="externe Lieferscheinnummer eingeben"
              />

              <label class="bm-fieldset-label" for="">Lieferdatum</label>
              <div class="bm-join w-full">
                <div class="bm-join-item bm-input">
                  <input 
                    [matDatepicker]="deliverPicker" 
                    (focus)="deliverPicker.open()" 
                    placeholder="Datum eingeben"
                    name="dp"
                    formControlName="deliveryDate"
                  />
                  <mat-datepicker #deliverPicker />
                </div>
                <button class="bm-join-item bm-btn bm-btn-square" (click)="deliverPicker.open()" type="button">
                  <span class="far fa-calendar-alt"></span>
                </button>
              </div>

              <label class="bm-fieldset-label" for="">Herstellungsdatum</label>
              <div class="bm-join w-full">
                <div class="bm-join-item bm-input">
                  <input 
                    [matDatepicker]="productionPicker" 
                    (focus)="productionPicker.open()" 
                    placeholder="Datum eingeben"
                    name="dp"
                    formControlName="productionDate"
                  />
                  <mat-datepicker #productionPicker />
                </div>
                <button class="bm-join-item bm-btn bm-btn-square" (click)="productionPicker.open()" type="button">
                  <span class="far fa-calendar-alt"></span>
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>

      <div class="bm-card flex-1 max-w-1/3">
        <div class="bm-card-body">
          <div class="bm-card-title">Seriennummern erfassen</div>
          @if (useSerialNumbers()) {
            <form [formGroup]="serialForm" (submit)="onSNSubmit(false)" class="bm-fieldset">
              <label for="inputSNNum" class="bm-fieldset-label">Seriennummer erfassen</label>
              <input
                class="bm-input w-full"
                type="text"
                #serialNumberInput
                id="inputSNNum"
                placeholder="Seriennummer"
                formControlName="serialInput"
              />
              <label id="passwordHelpBlock"> Enter zum Bestätigen </label>

              <div>
                oder per Massenerfassung:
              </div>

              <textarea
                class="bm-textarea w-full"
                type="text"
                #serialNumberInput
                id="inputSNNum"
                placeholder="Seriennummer"
                formControlName="serialMassInput"
              ></textarea>

              <button class="bm-btn bm-btn-block" type="button" (click)="onSNSubmit(true)">
                Mehrere Seriennummern erfassen
              </button>

              <div class="flex flex-row flex-wrap gap-1">
                @for (code of serialNumbers; track $index) {
                  <span class="bm-badge bm-badge-accent">{{ code }}</span>
                }
              </div>
              <div>
                Gescannte Codes: {{ serialNumberSize() }}
                @if (expectedSNCount()) {
                  <span>, es fehlen: {{ expectedSNCount() - serialNumberSize() }}</span>
                }
              </div>
            </form>
          } @else {
            <p>Eingabe ist nicht aktiviert, weil der Artikel nicht zur Eingabe von Seriennummern konfiguriert ist.</p>
          }
        </div>
      </div>

      <div class="bm-card flex-1 max-w-1/3">
        <div class="bm-card-body">
          <div class="bm-card-title">Prüfen und hinzufügen</div>
          <form [formGroup]="endForm">
            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">Anfangslager</label>
              <ng-select
                class="w-full"
                [items]="warehouses"
                bindLabel="combined_label"
                autofocus
                bindValue="combined_id"
                groupBy="name"
                #startWarehouse
                (close)="startWarehouse.blur()"
                placeholder="Anfangslager auswählen"
                formControlName="startWarehouse"
              />
              <label id="passwordHelpBlock"> Hier das Eingangslager bei Bentomax wählen </label>

              <label class="bm-fieldset-label" for="">Endlager</label>
              <ng-select
                [items]="warehouses"
                bindLabel="combined_label"
                autofocus
                bindValue="combined_id"
                groupBy="name"
                #endWarehouse
                (close)="endWarehouse.blur()"
                placeholder="Endlager auswählen"
                formControlName="endWarehouse"
              >
              </ng-select>
              <label id="passwordHelpBlock">
                Wenn die Artikel direkt nach der Erfassung in ein zweites Lager versendet werden sollen, kann hier das
                nächste Lager ausgewählt werden.<br />
                Dadurch werden die RMA Aufkleber mit neuem Lageraufdruck erzeugt und der passende Lieferschein erzeugt.
              </label>
            </fieldset>
          </form>

          <button class="bm-btn bm-btn-success bm-btn-block" (click)="createArticles()">
            Artikel erzeugen und einbuchen
          </button>
        </div>
      </div>
    </div>

    <div class="bm-card bg-base-100 border border-base-300 shadow-sm rounded-md w-full">
      <div class="bm-card-body">
        <div class="bm-card-title"></div>
        <div class="mockup-code w-full">
          <pre><code>{{ metaForm.getRawValue() | json }}</code></pre>
          <pre><code>{{ serialForm.getRawValue() | json }}</code></pre>
          <pre><code>{{ endForm.getRawValue() | json }}</code></pre>
        </div>
      </div>
    </div>
  </div>
</div>
